import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { DEMO_REQUEST_MAILTO } from '../config/contact';

/**
 * Floating "Request Demo" action that reveals after the user scrolls past
 * the hero. Gives every page a persistent low-friction path to a demo
 * without requiring the user to scroll all the way down to the footer CTA.
 */
const REVEAL_THRESHOLD_PX = 520;
const HIDE_NEAR_FOOTER_PX = 320;

const StickyDemoFab: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const scrolled = window.scrollY;
      const viewportHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const nearBottom = docHeight - (scrolled + viewportHeight) < HIDE_NEAR_FOOTER_PX;
      // Respect users who prefer reduced motion — still show, just without animation.
      setVisible(scrolled > REVEAL_THRESHOLD_PX && !nearBottom);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <Button
      component="a"
      href={DEMO_REQUEST_MAILTO}
      aria-label="Request a demo"
      endIcon={<ArrowForward sx={{ fontSize: '1rem' }} />}
      sx={{
        position: 'fixed',
        right: { xs: 16, md: 24 },
        bottom: { xs: 16, md: 24 },
        zIndex: 1200,
        borderRadius: '999px',
        px: { xs: 2.2, md: 2.6 },
        py: { xs: 1.1, md: 1.25 },
        backgroundColor: 'var(--brand-primary)',
        color: 'white',
        textTransform: 'none',
        fontWeight: 400,
        fontSize: { xs: '0.88rem', md: '0.94rem' },
        boxShadow: '0 18px 38px rgba(15,38,77,0.28), 0 2px 6px rgba(15,38,77,0.18)',
        pointerEvents: visible ? 'auto' : 'none',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 220ms ease, transform 220ms ease, background-color 200ms ease',
        '&:hover': { backgroundColor: '#2d4a84' },
      }}
    >
      Request Demo
    </Button>
  );
};

export default StickyDemoFab;
